/*
 * File: ContentLocalityBadge.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 3:53 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { memo, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

// Components
import { Emoji } from '../Emoji';

// Styles
import * as S from './ContentLocalityBadge.styles';
import { COUNTRY_OPTIONS } from '../../../constants/base.constants';
import { ToolTip } from '../ToolTip';


/**
 * Helpers
 */

const getFlagEmoji = (countryCode) => {
	const codePoints = countryCode
		.toUpperCase()
		.split('')
		.map((char) => 127397 + char.charCodeAt());
	return String.fromCodePoint(...codePoints);
};


/**
 * Component
 */

export const ContentLocalityBadge = memo(({
	className, country, id
}) => {

	// Handle actions on component load
	useEffect(() => {}, []);

	// Get country name
	const countryName = COUNTRY_OPTIONS.find(({ code }) => code === country.toUpperCase())?.name;

	// Get flag emoji
	const emoji = useMemo(() => getFlagEmoji(country), [country]);

	// Render component
	return country && emoji ? (
		<S.Wrapper className={className ? `${className} animate` : 'animate'} data-tip={countryName} data-for={id} id={id}>
			<ToolTip id={id} />
			<Emoji symbol={emoji} label={countryName} size={1.4} />
		</S.Wrapper>
	) : null;
});


/**
 * Configuration
 */

ContentLocalityBadge.displayName = 'ContentLocalityBadge';
ContentLocalityBadge.propTypes = {
	className: PropTypes.string,
	country: PropTypes.string,
	id: PropTypes.string
};
ContentLocalityBadge.defaultProps = {
	className: null,
	country: 'us',
	id: null
};
